/* eslint-disable */
export const outerWidth = (el) => {
  let width = el.offsetWidth;
  const style = getComputedStyle(el);

  width += parseInt(10, style.marginLeft) + parseInt(10, style.marginRight);
  return width;
};
